<template>
  <div class="page-home">
    <BannerSwiper />

    <HomeNews />
    <HomeIndustry />

    <PartnerLogos />
    <ContactSection />
  </div>
</template>

<script>
import BannerSwiper from '@/components/BannerSwiper.vue'
import PartnerLogos from '@/components/PartnerLogos.vue'
import ContactSection from '@/components/ContactSection.vue'
import HomeNews from '@/components/HomeNews.vue'
import HomeIndustry from '@/components/HomeIndustry.vue'

export default {
  name: 'HomePage',
  components: {
    BannerSwiper,
    PartnerLogos,
    ContactSection,
    HomeNews,
    HomeIndustry
  }
}
</script>

<style scoped>
.page-home {
  background: #f4f8fc;
}
</style>
